import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=55f70a70&scoped=true"
var script = {}
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=55f70a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f70a70",
  null
  
)

export default component.exports